export const wxIdentitySelectedUrl = "page/common/identitySelected/identitySelected";
